//AdminLogin.jsx
import React, { useState } from "react";
import { CiLock } from "react-icons/ci";
import { IoMailOpenOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "../../assets/styles/AdminLoginStyles/AdminLogin.css";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import {
  loginSuperAdmin,
  loginAdmin,
  loginEmployee,
  trustThisDevice,
} from "../../services/LoginAuthService/LoginAuthService";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showEmailField, setShowEmailField] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // State for pop-up
  const [showPopup2, setShowPopup2] = useState(false); // State for pop-up
  const [loading, setLoading] = useState(false); // Loading state
  const [role, setRole] = useState("superadmin"); // Default role
  const [errorPopUP, setErrorPopUP] = useState("");
  const [otp, setOtp] = useState("");
  const [trustDevice, setTrustDevice] = useState(false);

  const navigate = useNavigate();

  const TrustedDevice = async () => {
    try {
      setLoading(true);
      const accessToken = localStorage.getItem("access_token");
      const userRole = localStorage.getItem("userType"); // Get the user's role from storage

      // Call verifyOtp service with role
      const response = await trustThisDevice(
        otp,
        trustDevice,
        accessToken,
        userRole
      );

      if (response.response === true) {
        navigate("/admin-dashboard"); // Redirect on success
      } else {
        setErrorPopUP("Invalid OTP. Please try again.");
      }
    } catch (error) {
      setErrorPopUP(error.message || "Failed to verify OTP.");
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    let validationErrors = {};

    if (!email.trim()) {
      validationErrors.email = "This field is required";
    } else if (!validateEmail(email)) {
      validationErrors.email = "Invalid email format";
    }

    const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    if (!password.trim()) {
      validationErrors.password = "This field is required";
    } else if (!passwordRegex.test(password)) {
      validationErrors.password =
        "Password must have at least 8 characters, 1 number, and 1 special character";
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length !== 0) return;

    setLoading(true);
    try {
      let response;
      let credentials;

      // Prepare credentials based on the selected role
      switch (role) {
        case "superadmin":
          credentials = { a_email: email, a_password: password }; // Super Admin fields
          response = await loginSuperAdmin(credentials);
          break;
        case "admin":
          credentials = { a_email: email, a_password: password }; // Admin fields (adjust if different)
          response = await loginAdmin(credentials);
          break;
        case "employee":
          credentials = { e_email: email, e_password: password }; // Employee fields (adjust if different)
          response = await loginEmployee(credentials);
          break;
        default:
          throw new Error("Invalid role selected");
      }

      // Store the response in local storage
      localStorage.setItem("resetToken", response.response);

      localStorage.setItem("resetToken", response.reset_token);
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("message", response.message);
      localStorage.setItem("userType", role); // Add this line to store user type

      if (response.response === false) {
        // Show the popup instead of navigating to /newpassword
        setShowPopup(true);
      } else if (
        response.message === "Login successful. Please verify your OTP."
      ) {
        setShowPopup2(true);
      } else {
        // Redirect based on role
        switch (role) {
          case "superadmin":
            navigate("/admin-dashboard");
            break;
          case "admin":
            navigate("/admin-dashboard");
            break;
          case "employee":
            navigate("/admin-dashboard");
            break;
          default:
            break;
        }
      }
    } catch (error) {
      // setErrorPopUP("Invalid Email or Password");
      setErrorPopUP(
        error.message ==
          "Your account is locked. Please contact your admin for assistance."
          ? error.message
          : "Invalid Email or Password"
      );
      // setErrorPopUP(error.message);

      console.log(errorPopUP);

      if (error.response?.data) {
        const apiErrors = error.response.data;
        setErrors({
          email: apiErrors.a_email?.[0] || "",
          password: apiErrors.a_password?.[0] || "",
          api:
            apiErrors.non_field_errors?.[0] ||
            "Login failed. Please try again.",
        });
      } else {
        setErrors({ api: "Login failed. Please try again." });
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="bg-gray-900 background w-full h-[100vh] flex items-center">
        <div className="flex justify-center mx-auto w-full h-[70vh] rounded-xl">
          <div className="z-10 relative flex flex-col justify-center w-full md:w-3/5 p-5 md:px-20 rounded-e-2xl">
            <div className="absolute -z-10 inset-0 border-2 border-red-600 rounded-xl backdrop-blur-sm bg-red-500/50"></div>
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex justify-center">
              <img
                src={require("../../assets/images/commonImages/ZeroMiddleMan Logo 3.png")}
                alt=""
                className="bg-white px-4 rounded-2xl w-32 md:w-48"
              />
            </div>
            <div className="mb-12">
              <div className="top-5 sm:top-5 md:top-auto absolute md:flex gap-2 flex-col right-5 md:right-10">
                <select
                  className="bg-transparent outline-none border-2 border-white text-white px-2 py-1 rounded-md"
                  name="role"
                  id="role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option className="text-black" value="superadmin">
                    Super Admin
                  </option>
                  <option className="text-black" value="admin">
                    Admin
                  </option>
                  <option className="text-black" value="employee">
                    Employee
                  </option>
                </select>
              </div>
              <h1 className="text-white text-sm md:text-lg font-light text-center">
                Please enter your Email Id and Password for Login
              </h1>
            </div>
            <div className="flex flex-col gap-5">
              {/* Email Label and Field */}
              <div className="flex flex-col">
                {!showEmailField && (
                  <div
                    className="px-2 flex items-center gap-2 cursor-pointer text-white py-2 outline-none border-b border-white bg-transparent"
                    onClick={() => setShowEmailField(true)}
                  >
                    <IoMailOpenOutline className="text-2xl text-semibold" />
                    <label className="font-semibold text-lg md:text-xl">
                      Email
                    </label>
                  </div>
                )}
                {showEmailField && (
                  <input
                    className="px-5 py-2 text-white placeholder-white placeholder:text-lg placeholder:font-semibold outline-none border-b bg-transparent w-full"
                    type="text"
                    placeholder="Enter your Email Address"
                    value={email}
                    name="a_email"
                    autoFocus
                    onChange={(e) => setEmail(e.target.value)}
                  />
                )}
                {errors.email && (
                  <p className="text-white text-sm">{errors.email}</p>
                )}
              </div>

              {/* Password Label and Field */}
              <div className="flex flex-col">
                {!showPasswordField && (
                  <div
                    className="px-2 flex items-center gap-2 cursor-pointer text-white py-2 outline-none border-b border-white bg-transparent"
                    onClick={() => setShowPasswordField(true)}
                  >
                    <CiLock className="text-2xl" />
                    <label className="font-semibold text-lg md:text-xl">
                      Password
                    </label>
                  </div>
                )}
                {showPasswordField && (
                  <div className="relative">
                    <input
                      className="px-5 py-2 text-white placeholder-white placeholder:text-lg placeholder:font-semibold outline-none border-b bg-transparent w-full"
                      type={passwordVisible ? "text" : "password"}
                      placeholder="Enter your Password"
                      value={password}
                      autoFocus
                      name="a_password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="absolute right-3 top-3 text-xl text-white cursor-pointer"
                      onClick={() => setPasswordVisible(!passwordVisible)}
                    >
                      {passwordVisible ? <AiFillEyeInvisible /> : <AiFillEye />}
                    </span>
                  </div>
                )}
                {errors.password && (
                  <p className="text-white text-sm mt-1">{errors.password}</p>
                )}
                <div className="flex justify-end pt-2">
                  <div>
                    <Link to="forgotpassword" className="underline text-white">
                      Forgot Password ?
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <p className="text-white text-center">{errorPopUP}</p>
            </div>

            {/* Login Button */}
            <div className="flex justify-center mt-5">
              <button
                className="px-10 py-2 bg-white text-[#ff0000] hover:bg-[#d93030] hover:text-white rounded-md"
                onClick={handleLogin}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Pop-up Modal */}
      {showPopup && (
        <div className="fixed z-20 inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-5/12">
            <div className="flex justify-end">
              <button
                className="p-2  text-3xl hover:blood text-blood"
                onClick={() => setShowPopup(false)}
              >
                <IoMdClose />
              </button>
            </div>
            <div className="px-20 py-4">
              <h2 className="text-lg font-semibold text-gray-800">
                You should change the email password for the first time
                (compulsory).
              </h2>

              <div className="mt-4 flex justify-center">
                <Link
                  to="newpassword"
                  className="px-10 py-2 bg-white font-semibold text-blood border-2 border-blood rounded-md hover:bg-red-600 hover:text-white"
                >
                  Change
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Pop-up Modal for verify OTP */}
      {showPopup2 && (
        <div className="fixed z-20 inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-5/12">
            <div className="flex justify-end">
              <button
                className="p-2  text-3xl hover:blood text-blood"
                onClick={() => setShowPopup2(false)}
              >
                <IoMdClose />
              </button>
            </div>
            <div className="px-20 py-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Login successful. Please verify your OTP.
              </h2>

              <input
                className="mt-4 px-4 py-2 border border-gray-300 rounded-md"
                type="text"
                placeholder="Enter your OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />

              <div className="mt-4 flex gap-2">
                <input
                  type="checkbox"
                  checked={trustDevice}
                  onChange={(e) => setTrustDevice(e.target.checked)}
                />
                <label htmlFor="">I Trust this Device for 15 days</label>
              </div>

              <div className="mt-4 flex justify-center">
                <button
                  onClick={TrustedDevice}
                  className="px-10 py-2 bg-white font-semibold text-blood border-2 border-blood rounded-md hover:bg-red-600 hover:text-white"
                  disabled={loading}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default AdminLogin;
